"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartDate = void 0;
var tslib_1 = require("tslib");
var moment_1 = (0, tslib_1.__importDefault)(require("moment"));
var getStartDate = function () {
    var amountOfDays = -29;
    return (0, moment_1.default)(new Date())
        .add(amountOfDays, 'days')
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate();
};
exports.getStartDate = getStartDate;
